import 'datatables.net-responsive-dt';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-fixedcolumns';
import 'datatables.net-fixedheader';
import 'datatables.net-scroller';
import {
    Component,
    Inject,
    Injectable,
    OnInit,
    Renderer2,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
    NavigationEnd,
    NavigationStart,
    Router,
    RouterOutlet,
    RoutesRecognized
} from '@angular/router';
import { GlobalService } from './core/services/global.service';
import { ScriptLoaderService } from './core/services/script-loader.service';
import { Helpers } from './helpers';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpParams,
    HttpRequest
} from '@angular/common/http';
import { UserService } from './core/services/user.service';
import { BsModalRef, ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { Observable, Subscription, catchError, filter, throwError } from 'rxjs';
import { DOCUMENT, NgClass } from '@angular/common';
import { ThemeService } from 'app/core/services/theme.service';

declare const gtag: Function; // eslint-disable-line
declare const $;
import { ServerService } from './core/services/server.service';
import { CsrfService } from './core/services/csrf.service';
import { environment } from 'environments/environment';
import { LoadingComponent } from './main/loading/loading.component';
import { AlertComponent } from './main/alert/alert.component';
import { ScrollTopComponent } from './main/scroll-top/scroll-top.component';
import { EntitySidebarComponent } from './main/entity-sidebar/entity-sidebar.component';
// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
import { SecurityService } from './core/services/security.service';
import { EntityService } from './core/services/entity.service';
// register Swiper custom elements
register();
@Component({
    selector: 'body',
    templateUrl: './app.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./app.component.scss'],
    imports: [
    RouterOutlet,
    EntitySidebarComponent,
    ScrollTopComponent,
    AlertComponent,
    LoadingComponent,
    ModalModule,
    NgClass
]
})
export class AppComponent implements OnInit {
    idleState = 'Not started.';
    timedOut = false;
    lastPing?: Date = null;
    globalBodyClassDark =
        'm-page--loading-non-block theme--dark m-page--wide m-header--fixed m-header--fixed-mobile m-footer--push m-aside--offcanvas-default';
    globalBodyClassDefault =
        'm-page--loading-non-block theme--default m-page--wide m-header--fixed m-header--fixed-mobile m-footer--push m-aside--offcanvas-default';
    private subscriptions: Subscription[] = [];
    private title: string;
    // alertHidden to prevent seeing big red boxes on initial page render
    public alertHidden = true;
    public modalRef: BsModalRef;
    public acknowledgeTimer: number = 5; // Timer for acknowledge button (5 seconds)
    public timerRunning: boolean = false; // Flag to track if timer is active
    public alertData: {
        id: string;
        title: string;
        description: string;
        author: string;
        isWebinar: number;
    };
    public alertArray: alertData[] = [];
    public arrayIndex: number = -1;

    @ViewChild('alertModal') alertModal: ModalDirective;
    public news;
    public transformedNews;
    constructor(
        private router: Router,
        public globalService: GlobalService,
        private titleService: Title,
        private script: ScriptLoaderService,
        private userService: UserService,
        private serverService: ServerService,
        private csrfService: CsrfService,
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        private themeService: ThemeService,
        private securityService: SecurityService,
        private entityService: EntityService
    ) {
        /** START : Code to Track Page View using gtag.js */
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                gtag('event', 'page_view', {
                    page_path: event.urlAfterRedirects
                });
            });
        /** END : Code to Track Page View  using gtag.js */

        //Add dynamic title for selected pages - Start
        router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const title = this.getTitle(
                    router.routerState,
                    router.routerState.root
                ).join(' > ');
                this.titleService.setTitle(title);
            }

            // add entities to label
            const title = this.titleService.getTitle();
            const entityLabel = this.entityService.selectedEntityLabel.toString();
            if (entityLabel != '' && !title.includes(entityLabel)) {
                this.titleService.setTitle(
                    this.titleService.getTitle() + ' | ' + entityLabel
                );
            }
        });

        //Add dynamic title for selected pages - End
        if (!environment.production) {
            console.debug('end constructor');
        }
    }
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    public getTitle(state, parent) {
        const data = [];
        if (parent && parent.snapshot.data && parent.snapshot.data.title) {
            data.push(parent.snapshot.data.title);
        }

        if (state && parent) {
            data.push(...this.getTitle(state, state.firstChild(parent)));
        }
        return data;
    }

    hideAlertModal(): void {
        this.alertModal.hide();
        this.resetTimer();
    }

    setAlertData(): void {
        this.alertData = {
            id: this.alertArray[this.arrayIndex]?.id,
            title: this.alertArray[this.arrayIndex]?.title,
            description: this.alertArray[this.arrayIndex]?.description,
            author: this.alertArray[this.arrayIndex]?.author,
            isWebinar: this.alertArray[this.arrayIndex]?.isWebinar
        };
    }

    private filterAcknowledgedAlerts(alerts: alertData[]): alertData[] {
        return alerts.filter((alert) => {
            return localStorage.getItem(alert.id) !== '1';
        });
    }

    onAlertAcknowledge(): void {
        localStorage.setItem(this.alertData?.id, '1');
        // remove alert from this.alertArray
        this.alertArray = this.alertArray.filter(
            (alert) => alert.id !== this.alertData?.id
        );
        this.resetTimer();

        // If we're viewing an array of alerts
        if (this.alertArray.length > 0) {
            // If there are more alerts to see
            if (this.arrayIndex < this.alertArray.length) {
                this.resetTimer();
                this.startTimer();
                this.arrayIndex = 0;
                this.setAlertData();
            } else {
                // No more alerts, hide modal
                this.alertData = undefined;
                this.alertModal.hide();
            }
        } else {
            // Not viewing an array of alerts, just hide the modal
            this.alertData = undefined;
            this.alertModal.hide();
        }
    }

    startTimer(): void {
        this.timerRunning = true;
        this.acknowledgeTimer = 5;
        const timerInterval = setInterval(() => {
            this.acknowledgeTimer--;
            if (this.acknowledgeTimer <= 0) {
                clearInterval(timerInterval);
                this.timerRunning = false;
            }
        }, 1000);
    }

    resetTimer(): void {
        this.acknowledgeTimer = 5;
        this.timerRunning = false;
    }

    onPrevClick(): void {
        //this.prevClick = true;
        if (this.arrayIndex < this.alertArray.length) {
            this.resetTimer();
            this.startTimer();
            this.arrayIndex++;
            this.setAlertData();
        }
    }
    onNextClick(): void {
        if (this.arrayIndex > -1) {
            this.resetTimer();
            this.startTimer();
            this.arrayIndex--;
            this.setAlertData();
        }
    }

    async ngOnInit(): Promise<void> {
        if (!environment.production) {
            console.debug('start ngOnInit');
        }

        // Clean up any invalid CSRF tokens from localStorage at startup
        const existingToken = localStorage.getItem('x-csrf-token');
        if (
            existingToken &&
            (existingToken === 'undefined' || existingToken.trim() === '')
        ) {
            if (!environment.production) {
                console.warn('Cleaning up invalid CSRF token at startup:', existingToken);
            }
            localStorage.removeItem('x-csrf-token');
        }

        const url = window.location.href;
        console.log('🔍 [AppComponent] Current URL:', url);
        if (url.includes('?')) {
            const httpParams = new HttpParams({ fromString: url.split('?')[1] });
            const extractedCode = httpParams.get('code');

            if (extractedCode) {
                // Check if this code is already being processed by another tab
                const processingCode = localStorage.getItem('oauth-processing-code');
                const processingTimestamp = localStorage.getItem(
                    'oauth-processing-timestamp'
                );
                const now = Date.now();

                // If another tab is processing a different code or processing expired (>30 seconds ago)
                if (
                    !processingCode ||
                    processingCode !== extractedCode ||
                    (processingTimestamp && now - parseInt(processingTimestamp) > 30000)
                ) {
                    console.log(
                        '🔍 [AppComponent] Setting OAuth code for processing:',
                        extractedCode.substring(0, 10) + '...'
                    );
                    this.userService.oAuthCode = extractedCode;
                    // Mark this code as being processed by this tab
                    localStorage.setItem('oauth-processing-code', extractedCode);
                    localStorage.setItem('oauth-processing-timestamp', now.toString());
                } else {
                    console.warn(
                        '🔍 [AppComponent] OAuth code already being processed by another tab, ignoring'
                    );
                    this.userService.oAuthCode = null;
                }
            }
            console.log(
                '🔍 [AppComponent] Final OAuth code:',
                this.userService.oAuthCode
                    ? this.userService.oAuthCode.substring(0, 10) + '...'
                    : 'none'
            );
        } else {
            console.log('🔍 [AppComponent] No query parameters found');
        }

        // Block the app from proceeding until CSRF is properly initialized
        if (!environment.production) {
            console.info(
                '⏳ [AppComponent] Initializing CSRF token before app startup...'
            );
        }

        try {
            // Always refresh CSRF token at startup instead of validating old ones
            // This ensures we start with a fresh, valid token
            const _newCsrfToken = await this.csrfService.refreshCsrfTokenPromise();
            this.csrfService.set(_newCsrfToken);
            if (!environment.production) {
                console.log('✅ [AppComponent] CSRF token initialized successfully');
            }
        } catch (error) {
            if (!environment.production) {
                console.error(
                    '❌ [AppComponent] Failed to initialize CSRF token:',
                    error
                );
            }
            // Even if it fails, allow the app to continue but mark CSRF as not ready
            // The server service will handle individual request failures
        }

        // Now signal that CSRF is ready - this unblocks components that wait for it
        if (!environment.production) {
            console.info(
                '🚀 [AppComponent] CSRF ready - signaling components can proceed'
            );
        }
        this.csrfService.on_ready.next(true);

        this.script
            .loadScripts('body', ['assets/demo/demo5/base/scripts.bundle.js'], true)
            .then(() => {
                this.script
                    .loadScripts(
                        'head',
                        ['./assets/vendors/custom/freshdesk_v2.js'],
                        true
                    )
                    .then(() => {
                        this.router.events.subscribe((route) => {
                            if (route instanceof NavigationStart) {
                                const theme = localStorage.getItem('theme');
                                Helpers.setLoading(true);
                                if (theme && theme === 'dark') {
                                    Helpers.bodyClass(this.globalBodyClassDark);
                                } else {
                                    Helpers.bodyClass(this.globalBodyClassDefault);
                                }
                            }
                            if (route instanceof RoutesRecognized) {
                                this.title = null;
                                let _route = route.state.root;
                                while (_route.firstChild) {
                                    _route = _route.firstChild;
                                    if (_route.data && _route.data.title) {
                                        this.title = _route.data.title;
                                    }
                                }
                            }
                            if (route instanceof NavigationEnd) {
                                // subscribe to router events and send page views to Google Analytics
                                if (
                                    this.userService.user &&
                                    this.serverService.shouldMakeApiCalls()
                                )
                                    this.serverService.post(
                                        'access/logAccess',
                                        {
                                            page: route.urlAfterRedirects,
                                            user_id: this.userService.user.user_id
                                        },
                                        (data) => {
                                            if (
                                                route?.url !== '/Logout' &&
                                                route?.url !== '/logout'
                                            ) {
                                                if (data?.length) {
                                                    const parsedData = data.map(
                                                        (element) =>
                                                            this.securityService.decodeFormData(
                                                                element
                                                            )
                                                    );

                                                    const unacknowledgedAlerts =
                                                        this.filterAcknowledgedAlerts(
                                                            parsedData
                                                        );

                                                    if (unacknowledgedAlerts.length > 0) {
                                                        this.alertArray =
                                                            unacknowledgedAlerts;
                                                        this.alertHidden = false;
                                                        this.arrayIndex = 0;
                                                        this.setAlertData();
                                                        this.alertModal.show();
                                                        this.startTimer();
                                                    } else {
                                                        this.alertData = undefined;
                                                    }
                                                } else {
                                                    this.alertData = undefined;
                                                }
                                            }
                                        }
                                    );

                                this.globalService.loading(false);
                                Helpers.setLoading(false);
                                if (this.title) {
                                    // Update title
                                    this.titleService.setTitle(this.title);
                                }
                            }
                        });
                    });
            });
        // window.FreshWidget.init("", {"loadOnEvent": 'immediate',"queryString": "&widgetType=popup", "utf8": "✓", "widgetType": "popup", "buttonType": "text", "buttonText": "Support", "buttonColor": "white", "buttonBg": "#BF9000", "alignment": "2", "offset": "235px", "formHeight": "500px", "url": "https://radissonhotelgroup.freshservice.com"} );
    }

    public async sendWebinarInvite(event, webinar): Promise<void> {
        // Block API calls if session is invalid or logout is in progress
        if (!this.serverService.shouldMakeApiCalls()) {
            console.log(
                '🚪 [AppComponent] Skipping sendWebinarInvite - session invalid or logout in progress'
            );
            return;
        }

        this.serverService.post(
            'dashboard/docs/add_email',
            {
                email: event.email,
                webinar: webinar
            },
            (_data) => {}
        );
        localStorage.setItem(this.alertData?.id, '1');
        this.hideAlertModal();
    }

    // ngAfterViewInit(): void {
    //     this.router.events.subscribe((event) => {
    //         // I check for isPlatformBrowser here because I'm using Angular Universal, you may not need it
    //         if (event instanceof NavigationEnd) {
    //             console.log(ga); // Just to make sure it's actually the ga function
    //             ga('set', 'page', event.urlAfterRedirects);
    //             ga('send', 'pageview');
    //         }
    //     });
    // }
    private async verifyCsrf(): Promise<void> {
        try {
            const _isCsrfTokenValid = await this.csrfService.validateCsrfToken();
            if (!_isCsrfTokenValid) {
                if (!environment.production) {
                    console.log('[AppComponent] CSRF token invalid, refreshing...');
                }
                const _newCsrfToken = await this.csrfService.refreshCsrfTokenPromise();
                this.csrfService.set(_newCsrfToken);
                if (!environment.production) {
                    console.log('[AppComponent] CSRF token refreshed successfully');
                }
            } else {
                if (!environment.production) {
                    console.log('[AppComponent] CSRF token is valid');
                }
            }
        } catch (error) {
            if (!environment.production) {
                console.error('[AppComponent] Error during CSRF verification:', error);
            }
            // Try to refresh the token even if validation failed
            try {
                const _newCsrfToken = await this.csrfService.refreshCsrfTokenPromise();
                this.csrfService.set(_newCsrfToken);
                if (!environment.production) {
                    console.log('[AppComponent] CSRF token refreshed after error');
                }
            } catch (refreshError) {
                if (!environment.production) {
                    console.error(
                        '[AppComponent] Failed to refresh CSRF token:',
                        refreshError
                    );
                }
            }
        }
    }

    public ngAfterViewInit(): void {
        this.setUserSelectedTheme();
        this.subscriptions.push(
            this.themeService.themeChanged$.subscribe((theme: string) => {
                this.switchTheme(theme);
            })
        );
    }

    public setUserSelectedTheme(): void {
        const theme = localStorage.getItem('theme');
        const htmlNode = this.document.getElementsByTagName('html')[0];
        const bodyNode = this.document.getElementsByTagName('body')[0];
        if (!theme) {
            this.renderer.setAttribute(htmlNode, 'theme-data', 'light');
            this.renderer.removeClass(bodyNode, 'theme--dark');
            this.renderer.addClass(bodyNode, 'theme--default');
            this.themeService.mode = 'light';
            return;
        }
        if (theme === 'dark') {
            this.renderer.setAttribute(htmlNode, 'theme-data', 'dark');
            this.renderer.removeClass(bodyNode, 'theme--default');
            this.renderer.addClass(bodyNode, 'theme--dark');
            this.themeService.mode = 'dark';
        } else {
            this.renderer.setAttribute(htmlNode, 'theme-data', 'light');
            this.renderer.removeClass(bodyNode, 'theme--dark');
            this.renderer.addClass(bodyNode, 'theme--default');
            this.themeService.mode = 'light';
        }
    }

    public switchTheme(theme: string): void {
        if (theme === this.themeService.mode) return;
        const htmlNode = this.document.getElementsByTagName('html')[0];
        const bodyNode = this.document.getElementsByTagName('body')[0];
        const attr = htmlNode.getAttribute('theme-data');
        if (attr === 'dark') {
            this.renderer.setAttribute(htmlNode, 'theme-data', 'light');
            this.renderer.removeClass(bodyNode, 'theme--dark');
            this.renderer.addClass(bodyNode, 'theme--default');
            this.themeService.mode = 'light';
        } else {
            this.renderer.setAttribute(htmlNode, 'theme-data', 'dark');
            this.renderer.removeClass(bodyNode, 'theme--default');
            this.renderer.addClass(bodyNode, 'theme--dark');
            this.themeService.mode = 'dark';
        }
        localStorage.setItem('theme', this.themeService.mode);
        // window.location.reload();
    }
}
@Injectable()
export class CustomInterceptor implements HttpInterceptor {
    constructor() {
        //console.log('CustomInterceptor constructor');
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //console.log('CustomInterceptor intercept: ' + req.url);
        const cookieheaderName = 'x-csrf-token';
        const csrfToken = localStorage.getItem('x-csrf-token');
        // Only set CSRF token if it's valid (not null, undefined, or string 'undefined')
        if (
            csrfToken &&
            csrfToken !== 'undefined' &&
            !req.headers.has(cookieheaderName)
        ) {
            //console.log('clone req: ' + req.url + ' with csrfToken: ' + csrfToken);
            req = req.clone({
                headers: req.headers.set(cookieheaderName, csrfToken)
            });
        }
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    if (!environment.production) {
                        console.log('CustomInterceptor 401 error');
                    }
                } else if (error.status === 405) {
                    // CSRF validation error - need to refresh token
                    if (!environment.production) {
                        console.log(
                            'CustomInterceptor 405 CSRF error - token may be invalid'
                        );
                    }
                    // Let the error propagate so the CSRF service can handle it
                } else {
                    if (!environment.production) {
                        console.log('CustomInterceptor error: ' + error.message);
                    }
                }
                return throwError(() => error);
            })
        );
    }
}

interface alertData {
    id: string;
    title?: string;
    description?: string;
    author: string;
    isWebinar?: number;
}
